import axios from 'axios';
import { JsBridge } from '@ie-activity/oversea-act-js-lib'
import { getLang } from './util';
import getRegion from './getRegion';
import { getConfig } from './config';

class HttpService {
  _getHeader(data = {}, options = {}) {
    let testToken = 'XX.FB_bE9MM3V3WHdka3VLNGpYaE1aODZLSFpzVEIyTmUvUXJRNGdTREUwbDNubWNibGVhZDhtTUxVZkdnM2pvbUF3SmtoMEdnNXREcTJpbDFtOVRKdTZRbGc9PQ'
    let header = {
      'Content-Type': 'application/json; charset=UTF-8',
      Accept: 'application/json; charset=UTF-8',
      t: Date.now(),
      // traceId: options.traceId || (await this.util.getUrid()),
      locale: getLang() + ';' + getRegion(),
      instPlatCode: -1,
      shieldGameBattle: false,
      ctime: Date.now(),
      // jitsSi: -1,
      id: JsBridge.getEnv() === 'gameHall' ? (window.android.getImei() || '') : '',
      ua: 'OPPO/PBEM00/27/8.1.0/V5.2.1/20162/2507/90909',
      // token: JsBridge.getToken(),
      token: JsBridge.getEnv() === 'gameHall' ? (JsBridge.getToken() || '') : '',
      // token: 'XX.FB_bE9MM3V3WHdka3VLNGpYaE1aODZLSFpzVEIyTmUvUXJRNGdTREUwbDNubWNibGVhZDhtTUxVZkdnM2pvbUF3SmtoMEdnNXREcTJpbDFtOVRKdTZRbGc9PQ'
    };
    if (JsBridge.getEnv() === 'oppoBrowser') {
      header.loginType = 3
    }
    // if (!(options.header && options.header.jitsSi)) {
    //   header.jitsSi = crypto.sign(objToSortedQueryStr(data));
    // }
    // return Object.assign({}, header, options.header);
    return header;
  }
  async request(type, url, data = {}, options = {}) {
    let header;
    try {
      header = this._getHeader();
    } catch (error) {
      console.log(error, 'error');
    }
    let errRet = null;
    let requestData = {};
    if (type.toLowerCase() === 'get') {
      requestData = {
        params: data
      };
    } else {
      requestData = {
        data: data
      };
    }
    let config = await getConfig();
    let baseUrl = config.urlMap.baseUrl;
    let ret = await axios({
      ...requestData,
      url: baseUrl + url,
      data: data,
      responseType: options.responseType || 'json',
      headers: header,
      method: type
    }).catch((err) => {
      console.log(`HttpService//${type}/err/${JSON.stringify(err)}`);
      errRet = {
        msg: err.message,
        code: (err.response && err.response.status) || '404'
      };
      if (err.message === 'Network Error') {
        console.log('inittt')
        errRet = {
          message: err.message,
          code: 'failed'
        }
      }
      // JsBridge.makeToast(errRet.msg)
    });
    if (errRet) {
      return errRet;
    }
    console.log(
      `HttpService//${type}/url:${url},header:${JSON.stringify(header)},data:${JSON.stringify(
        data
      )},options:${JSON.stringify(options)},ret.code:${ret.status},timecost:${Date.now() - header.ctime}`
    );
    if (ret.status === 200) {
      return ret.data;
    }
    return ret;
  }
  async post(...args) {
    return this.request('POST', ...args);
  }
  async get(...args) {
    return this.request('GET', ...args);
  }
}

export default HttpService;



// WEBPACK FOOTER //
// ./src/utils/http.js